import styled from 'styled-components';
import { DropDownButton, getSpacingToken } from '@optimus-web/core';

export const OrderItemDropdownButton = styled(DropDownButton)`
    margin-right: -${getSpacingToken('100')}px;
`;
